/**
 * s766: «этот звонок начал я сам» — отметка для окна входящего звонка.
 *
 * Звонок из карточки, набор с выбранной линии и перезвон по пропущенному начинает станция: сначала
 * она звонит в браузер менеджера. Для браузера это такой же входящий вызов, как звонок клиента, —
 * а человеку, который только что сам нажал «Позвонить», ни окно «Входящий звонок», ни звонок-сигнал
 * не нужны. Отметку ставит кнопка, снимает первый же пришедший вызов; живёт она недолго и видна
 * всем окнам этого браузера (нажать могли в одном окне, а телефон держит другое).
 */
const KLYUCH = 'opsmind.tel.svoy_nabor';

/** Сколько ждём вызова станции после нажатия: дольше — это уже чужой звонок. */
export const SVOY_NABOR_MS = 20_000;

export function otmetitSvoyNabor(): void {
  try {
    window.localStorage.setItem(KLYUCH, String(Date.now()));
  } catch { /* хранилище закрыто — окно разберётся по ответу сервера */ }
}

/** Пришёл вызов: он мой собственный? Отметка при этом снимается — один набор, один вызов. */
export function vzyatSvoyNabor(seychas: number = Date.now()): boolean {
  try {
    const kogda = Number(window.localStorage.getItem(KLYUCH) ?? 0);
    window.localStorage.removeItem(KLYUCH);

    return kogda > 0 && seychas - kogda < SVOY_NABOR_MS;
  } catch {
    return false;
  }
}
